import { resolve_onboarding_journey_filter } from '@/services/onboarding_journey_filter_service';

export function normalize_role(role) {
  return String(role || '').trim().toLowerCase();
}

export function is_case_owner_role(role) {
  const normalized_role = normalize_role(role);
  return (
    normalized_role.includes('case owner')
    || normalized_role.includes('case_owner')
    || normalized_role === 'owner'
    || normalized_role.endsWith(' owner')
  );
}

export function is_requestor_role(role) {
  const normalized_role = normalize_role(role);
  const requestor_words = ['entity', 'requestor', 'requester'];

  return requestor_words.some(function role_matches(word) {
    return normalized_role.includes(word);
  });
}

export function is_applicant_role(role) {
  return normalize_role(role) === 'entity';
}

export function is_coordinator_role(role) {
  const normalized_role = normalize_role(role);
  return normalized_role.includes('coordinator') || normalized_role === 'coord' || normalized_role === 'coordinator';
}

function first_initial(part) {
  return part[0];
}

export function compact_text(value) {
  return String(value || '').trim();
}

export function is_present(value) {
  return Boolean(value);
}

export function build_initials(name, fallback) {
  const initials = String(name || '')
    .split(' ')
    .filter(Boolean)
    .map(first_initial)
    .join('')
    .slice(0, 2)
    .toUpperCase();

  return initials || fallback;
}

export function build_case_owner_profile(current_lead_name) {
  const profile = {
    initials: build_initials(current_lead_name, 'SN'),
    name: current_lead_name || '',
    role_label: 'SENIOR ADJUSTER',
    scope_label: 'GAUTENG',
    metrics: [
      { label: 'Onboardings', value: '142' },
      { label: 'This wk', value: '18h' },
      { label: 'SLA', value: '94%' }
    ],
    panel_id: 'PN-0142',
    metric_cards: [
      { label: 'Open caseload', value: '142', detail: 'Within capacity (165)' },
      { label: 'SLA compliance', value: '94%', detail: 'Up 6 pts vs Q1' },
      { label: 'Avg. resolution', value: '18d', detail: 'Down from 27d' },
      { label: 'Override rate', value: '3.2%', detail: 'Below peer median' }
    ],
    contact_rows: [
      { label: 'Email', value: 's.naidoo@x-verdict.tenant' },
      { label: 'Mobile', value: '+27 82 411 0142' },
      { label: 'Coordinator', value: 'Claims Ops - Gauteng (T. Mahlangu)' },
      { label: 'Working hours', value: 'Mon-Fri - 07:30-17:00 SAST' },
      { label: 'Onboarded', value: '14 March 2022' },
      { label: 'Out-of-office', value: 'Available' }
    ],
    specialties: [
      { label: 'Motor claims', badge_class: 'bg-primary-subtle text-primary-emphasis' },
      { label: 'Property', badge_class: 'bg-primary-subtle text-primary-emphasis' },
      { label: 'Procurement oversight', badge_class: 'bg-warning-subtle text-warning-emphasis' },
      { label: 'Site safety', badge_class: 'bg-danger-subtle text-danger-emphasis' }
    ],
    authorisation_cap: 'R 250,000 own-decision - escalate above',
    fais: 'Cat I - Short-term personal lines - valid through 2027',
    cpd: '34 / 40 hrs (year to date)',
    case_snapshot: [
      { label: 'Decisions due', value: '3', border_class: 'is-danger' },
      { label: 'In review', value: '8', border_class: 'is-success' },
      { label: 'Pending evidence', value: '24', border_class: 'is-warning' },
      { label: 'In progress', value: '92', border_class: 'is-success' },
      { label: 'Closed (30d)', value: '15', border_class: 'is-muted' }
    ]
  };

  return profile;
}

export function get_badge_count(badges, badge_id) {
  const badge_map = new Map(Object.entries(badges || {}));
  return badge_map.get(String(badge_id));
}

export function resolve_selected_journey_id(route) {
  return String(resolve_onboarding_journey_filter(route).id || '').trim();
}

export function resolve_selected_journey_label(route) {
  return String(resolve_onboarding_journey_filter(route).label || '').trim();
}
